module.exports = __webpack_public_path__ + "img/Maryana.600092a6.png";